document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 990) return;

  document.querySelectorAll('header details').forEach(details => {
    details.addEventListener('mouseenter', () => {
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', () => {
      details.setAttribute('open', '');
    });
  });
});
